export default "__VITE_ASSET__a4d93dd3__"